import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { updateAffiliate } from 'utils/affiliate.utils';
import { queryParam } from 'utils/api.utils';

import { QueryParam } from 'types/embed.types';

export const useTrackAffiliateSource = () => {
  const { query } = useRouter();
  const affiliate = queryParam(query, QueryParam.Affiliate, undefined);

  useEffect(() => {
    if (affiliate) {
      // eslint-disable-next-line deprecation/deprecation
      updateAffiliate(affiliate);
    }
  }, [affiliate]);
};
